import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthenticationService } from './authentication.service';
import { environment } from '../environments/environment';

/**
 * 2026-07-09 — Änderungsprotokoll (broadcast audit log): stamp the current
 * Cognito username into every backend call (REST + the HotChocolate GraphQL
 * HttpLink, which also rides Angular's HttpClient). The backend middleware
 * captures X-KIUT-User into its ambient actor context so broadcast writes are
 * attributed to the operator; requests without the header are logged as
 * "System". Same client-asserted trust level as the existing TouchedBy →
 * Editors convention.
 */
export const userHeaderInterceptor: HttpInterceptorFn = (req, next) => {
  if (
    req.url.startsWith(environment.API_Base) ||
    req.url.startsWith(environment.backendGraphQLUrl)
  ) {
    const auth = inject(AuthenticationService);
    let user = '';
    try {
      // userName() reads the claims signal, which is null before login
      // completes — treat any failure as "no user yet".
      user = auth.userName() || '';
    } catch {
      user = '';
    }
    if (user) {
      req = req.clone({ setHeaders: { 'X-KIUT-User': user } });
    }
  }
  return next(req);
};
